import styled, { css, keyframes, RuleSet } from 'styled-components';
import { FlexibleDiv } from '../../../styled/common';

export const TooltipWrapper = styled.div<{
  $wrapperWidth?: number;
  $wrapperHeight?: number;
}>`
  display: inline-block;
  position: relative;
  ${({ $wrapperWidth, $wrapperHeight }) => css`
    width: ${$wrapperWidth}px;
    height: ${$wrapperHeight}px;
  `}
`;

const showFromTop = keyframes`
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
`;

export const TooltipContainer = styled(FlexibleDiv)<{
  $tooltipTopSpace?: number;
  $isVisible: boolean;
  $styles?: RuleSet<object>;
}>`
  position: absolute;
  justify-content: center;
  align-items: center;
  padding: 10px;
  width: fit-content;
  ${({ $tooltipTopSpace }) => css`
    top: ${$tooltipTopSpace}px;
  `}
  right: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 7px;
  background: ${({ theme }) => theme.colors.background.tertiary};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  animation: ${({ $isVisible }) =>
    $isVisible
      ? css`
          ${showFromTop} 0.2s ease-in-out forwards
        `
      : 'none'};
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;
  z-index: 9999;

  ${({ $styles }) => $styles};
`;
